import {http} from './config'

export default class EnumService{

  constructor(nomeControle){
    this._nomeControle = nomeControle;
  }

  Listar(){
    return http.get(`${this._nomeControle}`);
  }

}